import { FormArray } from '@trufla-technology/trumarket-react-design-system';
import { SwitchToggleInput } from '@trufla-technology/trumarket-react-design-system/lib/components/controls/SwitchToggleInput';
import { TextInput } from '@trufla-technology/trumarket-react-design-system/lib/components/controls/TextInput';
import { FormHookResult } from '@trufla-technology/trumarket-react-design-system/lib/components/widgets/TruForm/hooks/useForm';
import {
  emailRules,
  required,
} from '@trufla-technology/trumarket-react-design-system/lib/utils/validation_rules';
import './style.scss';
import { BranchFormType } from 'app/types/Branch';
import { customPhoneRules } from './phoneValidation';

const optionList = ['Phone', 'Cell', 'Fax'];

type propType = {
  changeValue: (key: string, value: boolean) => void;
  disabled: boolean;
  form: FormHookResult<BranchFormType>;
  primaryContactValidation: boolean;
};
export const PrimaryContactSection = ({
  changeValue,
  disabled,
  form,
  primaryContactValidation,
}: propType) => {
  return (
    <>
      <p className="title">Primary Contact </p>
      <div className="inputs-wrraper">
        <div className="global-toggle">
          <span className="label">Use Global</span>
          <form.Item className="flex-div" name="useGlobalPrimaryContact">
            <SwitchToggleInput
              value={disabled}
              onChange={(v) => {
                changeValue('useGlobalPrimaryContact', v);
              }}
            />
          </form.Item>
        </div>

        <form.Item
          name="primaryContact.name"
          label="Name"
          rules={primaryContactValidation ? [required] : []}
        >
          <TextInput disabled={disabled} />
        </form.Item>
        <form.Item
          name="primaryContact.title"
          label="Title"
          rules={primaryContactValidation ? [required] : []}
        >
          <TextInput disabled={disabled} />
        </form.Item>
        <FormArray
          Form={form}
          optionList={optionList}
          name="primaryContact.phones"
          typeLabel="Phone"
          buttonType="button"
          rules={
            primaryContactValidation
              ? [...customPhoneRules, required]
              : [...customPhoneRules]
          }
          disabled={disabled}
        ></FormArray>
        <form.Item
          name="primaryContact.email"
          label="Email"
          rules={
            primaryContactValidation
              ? [...emailRules, required]
              : [...emailRules]
          }
        >
          <TextInput disabled={disabled} />
        </form.Item>
      </div>
    </>
  );
};
